import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export const LEAD_CAPTURE = '/storefront/lead-capture'

// Two ways to collect the same signups, onto the same list: one page we host and
// they share, one form they paste into their own site. Named for whose page it
// is, because that is the only real difference between them.
const TABS = [
  { id: 'page', name: 'Hosted page', path: '' },
  { id: 'embed', name: 'Embedded form', path: '/embed' }
]

export const leadCapturePath = (tab = '') => `${LEAD_CAPTURE}${tab}`

export const leadCaptureEmbedPath = () => leadCapturePath('/embed')

export const leadCaptureTabs = currentPath =>
  TABS.map(tab => {
    const path = leadCapturePath(tab.path)
    return { id: tab.id, name: tab.name, path, active: currentPath === path }
  })

// Anything that is not the embed tab is the hosted page, so a report or a deeper
// path under here still reads as the page rather than as nothing.
export const leadCaptureTab = currentPath => leadCaptureTabs(currentPath).find(tab => tab.active)?.id ?? 'page'

// The tabs in the shape SecondaryTop's `sections` prop expects, so they render
// and behave like every other tabbed page in the dashboard. Route-backed rather
// than in-page sections, so `action` navigates and `active` comes from the route
// instead of SecondaryTop's scroll spy.
export function useLeadCaptureTabs() {
  const route = useRoute()
  const router = useRouter()

  const tabs = computed(() =>
    leadCaptureTabs(route.path).map(tab => ({
      id: tab.id,
      name: tab.name,
      active: tab.active,
      action: () => router.push(tab.path)
    }))
  )

  return { tabs, tab: computed(() => leadCaptureTab(route.path)) }
}
